<template>
    <div class="drafts-mail">
        <baseHeader :clickName.sync="indexName"></baseHeader>

        <section class="drafts-content" v-loading="loading.status" :element-loading-text="loading.txt">
            <div class="main-menu">
                <div class="menu-handle" v-if="menuHandle == 'all'">
                    <el-tooltip class="item" effect="light" content="搜索" placement="bottom-start">
                        <img @click="menuHandle = 'search'" src="./../../../assets/email/images/search.png" />
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="刷新" placement="bottom-start">
                        <img @click="refreshMail" src="./../../../assets/email/images/refresh.png" />
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="选择" placement="bottom-start">
                        <img @click="chooseList" v-if="!isChoose" src="./../../../assets/email/images/choose.png" />
                        <img @click="cancelChoose" v-else src="./../../../assets/email/images/choose-active.png" />
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="全选" placement="bottom-start">
                        <img @click="checkAll" v-if="!isAll" src="./../../../assets/email/images/check.png" />
                        <img @click="cancelChoose" v-else src="./../../../assets/email/images/check-active.png" />
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="删除" placement="bottom-start">
                        <img v-if="!isChoose || !isAll" src="./../../../assets/email/images/delete.png" />
                        <img v-if="isChoose || isAll" @click="deleteMail" src="./../../../assets/email/images/delete-active.png" />
                    </el-tooltip>
                    <el-tooltip class="item" id="sort_img" effect="light" content="排序" placement="bottom-start">
                        <img v-if="!isSort"  @click="sortList" src="./../../../assets/email/images/sort.png" />
                        <img v-else @click="cancelSort" src="./../../../assets/email/images/sort-active.png" />
                    </el-tooltip>
                </div>

                <div class="menu-handle menu-handle-search" v-if="menuHandle == 'search'">
                    <el-input
                        placeholder="邮件标题、邮件正文、发件人"
                        @input="getSerach"
                        v-model="menuSearch">
                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <span @click="cancelSearch">取消</span>
                </div>
                <div class="sort-filter" id="sort_box" v-if="isSort">
                    <div class="box-sort">
                        <div 
                            v-for="(item, index) in filterList" 
                            :key="index" 
                            :class="listParam.key1 == index ? 'text text-active' : 'text'" 
                            @click="handleFilter(index)">
                            {{item}}
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="box-sort">
                        <div  :class="listParam.key2 === 'desc' ? 'text text-active' : 'text'" @click="handleSort('desc')">降序</div>
                        <div  :class="listParam.key2 === 'asc' ? 'text text-active' : 'text'" @click="handleSort('asc')">升序</div>
                    </div>
                </div>

                <template v-if="searchMeunContent">
                    <div class="no-search-menu-content">无搜索匹配内容</div>
                </template>
                <template v-else>
                    <div v-if="listData.length > 0" class="menu-conten">
                        <el-scrollbar>
                            <el-checkbox-group v-model="selectedMail" @change="handleMailChange">
                                <template v-for="(item, index) in listData">
                                    <div 
                                        :key="index"
                                        :class="mailIndex == index ? 'menu-list menu-list-active': 'menu-list'"  
                                        @click="checkMail(item, index)">
                                        <span class="menu-left" v-if="isChoose || isAll">
                                            <el-checkbox :label="item.id"></el-checkbox>
                                        </span>
                                        <div class="menu-right">
                                            <div>
                                                <div>
                                                    <span>{{item.user_name}}</span>
                                                    <span>{{item.subject}}</span>
                                                </div>
                                            </div>
                                            <div class="time">
                                                <span>{{item.create_time}}</span>
                                                <img v-if="item.file.length > 0" src="./../../../assets/email/images/attachment.png" />
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-checkbox-group>
                        </el-scrollbar>
                        <div class="page-turning">
                            <span v-if="listParam.page_index != 1" @click="prePage"><i class="el-icon-arrow-left"></i></span>
                            <span v-else style="cursor: not-allowed;color: gainsboro;"><i class="el-icon-arrow-left"></i></span>
                            <span v-if="notNext" @click="nextPage"><i class="el-icon-arrow-right"></i></span>
                             <span v-else style="cursor: not-allowed;color: gainsboro;"><i class="el-icon-arrow-right"></i></span>
                        </div>
                    </div>
                    <div v-else class="no-menu-content">
                        <img src="./../../../assets/email/images/no-data.png" />
                        <p>暂无数据</p>
                    </div>
                </template>
            </div>

            <div class="main-conten" v-show="mailContent">
                <div class="send-mail-main">
                    <el-form :model="sendForm" :rules="rules" ref="sendForm" label-width="100px" class="demo-send-form">
                        <el-form-item label="收件人" prop="recipients" class="send-form-recipients">
                            <div v-if="recipientList.length > 0">
                                <span v-for="(item, index) in recipientList" :key="index">
                                    {{item.name}}<i class="el-icon-error" @click="clearReceiver(index)"></i><span>；</span>
                                </span>
                            </div>
                            <div v-else class="select-people">选择收件人</div>
                            <div class="send-form-reciver">
                                <span @click="show_recipic = !show_recipic">{{show_recipic ? '隐藏外部收件人' : '添加外部收件人'}}</span>
                                <span @click="show_cc = !show_cc">{{show_cc ? '隐藏抄送' : '显示抄送'}}</span>
                            </div>
                            <div class="send-form-btn">
                                <span @click="addFormRecipient">添加收件人</span>
                                <span @click="clearRecipient">清空</span>
                            </div>
                            <el-input v-model="sendForm.recipients" v-show="false"></el-input>
                        </el-form-item>
                        <el-form-item label="抄送" v-show="show_cc">
                            <div v-if="ccList.length > 0" class="send-form-cc">
                                <span v-for="(item, index) in ccList" :key="index">
                                    {{item.name}}<i class="el-icon-error" @click="clearCC(index)"></i><span>；</span>
                                </span>
                            </div>
                            <div v-else class="send-form-cc">选择收件人</div>
                            <div class="send-form-btn">
                                <span @click="addFormRecipient('cc')">添加收件人</span>
                                <span @click="clearRecipient('cc')">清空</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="外部收件人" v-show="show_recipic">
                            <el-input 
                                id="external_recipient" 
                                v-model="sendForm.externalRecipient" 
                                @blur="blurExternalRecipient" 
                                placeholder="输入正确的邮箱格式，用中文或英文 , 隔开">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Internet邮箱" v-show="show_recipic" class="send-form-internet">
                            <el-select v-if="internetList.length > 0" v-model="sendForm.internetMail" placeholder="请选择邮箱">
                                <el-option v-for="(item, index) in internetList" :key="index" :label="item.account" :value="item.id"></el-option>
                            </el-select>
                            <el-select v-else v-model="sendForm.internetMail" placeholder="请至邮箱设置中设置Internet邮箱">
                                <el-option v-for="(item, index) in internetList" :key="index" :label="item.account" :value="item.id"></el-option>
                            </el-select>
                            <span>通过该邮箱发邮件给外部收件人</span>
                        </el-form-item>
                        <el-form-item label="邮件主题" prop="subject">
                            <el-input v-model="sendForm.subject" maxlength="40" placeholder="40个字符以内"></el-input>
                        </el-form-item>
                        <el-form-item label="邮件内容" prop="post_content" class="mail-content">
                            <tinymce
                                id="d1"
                                ref="tm"
                                :plugins="plugins"
                                :other_options="tinymceOptions"
                                :toolbar1="toolbar1"
                                :toolbar2="toolbar2"
                                @editorInit="editorInit"
                                v-model="sendForm.post_content">
                            </tinymce>
                            <div class="tinymce-num">{{tinymceNum}} / 10000</div>
                        </el-form-item>
                        <el-form-item label="附件">
                            <span v-if="sendForm.attachment.length === 0" class="no-attachment">无附件</span>
                            <div v-else class="send-form-attachment-list">
                                <span v-for="(item, index) in sendForm.attachment" :key="index">
                                    <img src="./../../../assets/email/images/attachment.png" />
                                    <span>{{item.name}}</span>
                                    <i class="el-icon-error" @click="delAttachment(item.name)"></i>
                                </span>
                            </div>
                        </el-form-item>
                        <el-form-item label="附件">
                            <uploader
                                class="uploader-example"
                                ref="uploader"
                                :options="uploadOptions"
                                :file-status-text="statusText"
                                @file-added="fileAdded"
                                @files-submitted="fileSubmit"
                                @file-progress="fileProgress"
                                @file-removed="fileRemoved"
                                @file-success="fileSuccess"
                                @file-error="fileFail">
                                <uploader-unsupport></uploader-unsupport>
                                <uploader-btn :directory="false" :single="true" v-if="sendForm.attachment.length < 3 && !disabledUplader">上传附件</uploader-btn>
                                <el-button v-else class="disabled-uploader" disabled>上传附件</el-button>
                                <div :class="progressing ? 'uploader-progress-active' : 'uploader-progress'">
                                    <div>
                                        <el-progress :percentage="percentage" color="#33BBBB"></el-progress>
                                        <span @click="fileCancel">取消</span>
                                    </div>
                                </div>
                            </uploader>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="send-mail-footer">
                    <span @click="submitDrafts"><img src="./../../../assets/email/images/save.png" />保存至草稿箱</span>
                    <span @click="submitMail('sendForm')"><img src="./../../../assets/email/images/mail.png" />发送邮件</span>
                </div>
            </div>
            <div v-show="!mailContent" class="no-mail-data">
                <p class="text">从左侧选择邮件以查看</p>
            </div>
        </section>

        <el-dialog 
            title="选择人员" 
            :visible.sync="pop_up" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :before-close="closeRecipient"
            class="common-mail-dialog add-recipients-dialog" 
            width="850px">
            <div class="el-dialog-pop-up">
                <div>
                    <div>
                        <el-select v-model="plaformId" placeholder="请选择">
                            <el-option
                                v-for="(item, index) in plaformList"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="org-people-box">
                        <div id="scrollReceiver">
                            <div class="org-people-item" v-for="(item, index) in receiverList" :key="index">
                                <span>{{index+1}}.{{item.name}}</span>
                                <span v-html="showRoleName(item.role_name)"></span>
                                <span @click="addRecipient(index)">添加</span>
                            </div>
                        </div>
                        <p @click="addAllRecipient">全部添加</p>
                    </div>
                </div>
                <div>
                    <div class="el-dialog-pop-keyword">
                        <el-input v-model="receiver_keyword" placeholder="用户姓名"></el-input>
                        <el-button type="primary" @click="getReceiverData('search')">搜索</el-button>
                    </div>
                    <div class="el-show-pepole">
                        <div>
                            <div>
                                <span></span>
                                <span>账号</span>
                                <span>用户名</span>
                                <span>角色</span>
                                <span>所属组织</span>
                            </div>
                            <template v-if="people_lsit.length > 0">
                                <div v-for="(item, index) in people_lsit" :key="index">
                                    <span @click="deleteRecipient(index)">
                                        <i class="el-icon-error"></i>
                                    </span>
                                    <span>{{item.number}}</span>
                                    <span>{{item.name}}</span>
                                    <span v-html="showRoleName(item.role_name)"></span>
                                    <span>{{item.platform_name}}</span>
                                </div>
                            </template>
                        </div>
                        <p @click="people_lsit = []">全部移除</p>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" size="small" plain @click="closeRecipient">取 消</el-button>
                <el-button type="primary" size="small" @click="newRecipient">确 定</el-button>
            </span>
        </el-dialog>

        <transition name="el-fade-in-linear">
			<div class="video-preview" :class="{activeLive: isActive}">
				<div class="maskingBox"
					v-loading="viewLoading.status"
					:element-loading-text="viewLoading.txt">
					<div class="masking_h">
						<span>视频预览</span>
						<i class="el-icon-close" @click="closeVideoView"></i>
					</div>
					<div class="masking_c">
						<videoAlertView v-if="showVideoPlayer" :playParam.sync="playParam"></videoAlertView>
					</div>
				</div>
			</div>
		</transition>

        <transition name="el-fade-in-linear" lock-scroll="false">
			<div class="document-preview" :class="{activeLive: isPDFActive}">
				<div class="maskingBox">
					<div class="masking_h">
						<span>文档预览</span>
						<i class="el-icon-close" @click="closePdfView"></i>
					</div>

					<div class="masking_c">
                    <div>
                        <div class="pdf-view">
                            <div 
                                v-if="viwPdfParam.loadedRatio > 0 && viwPdfParam.loadedRatio < 1" 
                                style="background-color: green; color: white; text-align: center" 
                                :style="{ width: viwPdfParam.loadedRatio * 100 + '%' }">
                                {{ Math.floor(viwPdfParam.loadedRatio * 100) }}%
                            </div>
                            <pdf ref="pdf" 
                                :src="viwPdfParam.src" 
                                :page="viwPdfParam.page"   
                                @progress="viwPdfParam.loadedRatio = $event" 
                                @error="pdfError" 
                                @num-pages="viwPdfParam.numPages = $event" 
                                @link-clicked="viwPdfParam.page = $event">
                            </pdf>
                        </div>

                        <el-pagination
                            @current-change="pdfPageChange"
                            :current-page="viwPdfParam.page"
                            :page-size="1"
                            layout="total,  prev, pager, next, jumper"
                            :total="viwPdfParam.numPages">
                        </el-pagination>
                    </div>
				</div>
				</div>
			</div>
		</transition>

        <el-dialog
            title="图片预览"
            class="picture-preview"
            :visible.sync="imgVisible"
            :close-on-click-modal="false">
            <div>
                <img :src="imgViewUrl">
            </div>
        </el-dialog>

        <el-dialog
			title="音频预览"
            class="audio-preview"
			:visible.sync="voiceVisible"
            :before-close="closeAudio"
			:close-on-click-modal="false">
			<div>
				<audio id="voicepoauy" controls="controls" :src="voiceViewUrl" controlsList="nodownload">
				    Your browser does not support the audio tag.
				</audio>
			</div>
		</el-dialog>
    </div>
</template>

<script>
    import pdf from 'vue-pdf';
    import baseHeader from './basse-header';
    import axios from '../../../tools/axios';
    import tinymce from "vue-tinymce-editor";
    import {networkMailbox} from './../base/base.js';
    import videoAlertView from '@/components/common/videoAlertView';
    import CHINESE from '../../../assets/tinymce_languages/zh_CN.js';
    import AttachmentImg from './../../../assets/email/images/attachment.png';

    export default {
        data() {
            return {
                receiverCount: 0,
                isScroll: true,
                scrollT: 0,
                indexName: 'drafts',
                isSort: false, // 排序
                isAll: false, // 全选
                isChoose: false, // 选择
                mailContent: false, // 是否有邮件内容
                show_cc: false, // 显示抄送收件人
                pop_up: false, // 弹出收件人窗口
                show_recipic: false, // 显示外部收件人
                progressing: false, // 是否正在上传附件
                searchMeunContent: false, // 搜索结果为空
                disabledUplader: false, // 上传附件过程中，不可以在上传
                isExternalRecipient: false, // 外部邮箱输入是否正确
                notNext: false, // 下一页不可点击
                isId: false, // 是否带上id查询
                timerSearch: null,
                sessionId: null, // 打开邮件的id
                uploadRetryTimes: 10, // 上传附件失败重新上传次数
                percentage: 0, // 附件上传进度
                tinymceNum: 0,
                totalNum: 0, // 邮件总页数
                editLoad: 0, // 编辑器未初始化前，watch 不能做操作
                mailIndex: null,  // 打开邮件列表的下标
                home_header: null, // html dom
                home_main: null, // html dom
                plaformId: null, // 收件人的组织架构
                receiver_keyword: '', // 收件人搜索关键字
                menuSearch: '',
                menuHandle: 'all', // 搜索  all | search
                toolbar1: "paste,fullscreen,link,image", // 编辑器工具栏
                toolbar2: "formatselect  | fontsizeselect | forecolor backcolor | fontselect bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | removeformat", // 编辑器工具栏
                listData: [], // 邮件列表
                selectedMail: [], // 选中邮件
                ccList: [], // 选中的抄送人列表
                recipientList: [], // 选中的收件人列表
                internetList: [], // 网络邮箱
                plaformList: [], // 组织架构
                people_lsit: [], // 选中的收件人
                receiverList: [], // 组织架构下的用户
                filterList: ['日期', '附件'], // 邮件帅选条件
                plugins: ["paste", "fullscreen", "link", "image"], // 编辑器插件
                loading:{
					status:false,
					txt:'获取数据...',
				},
                itemDetail: {}, // // 邮件详情信息
                listParam: {
                    key1: 0,  // file：文件,create_time:日期，create_id：发件人，is_read:是否已读
                    key2: 'desc', // desc:降序（默认），asc:升序
                    page_index: 1,
                    page_size: 12
                },
                sendForm: { // 邮件表单
                    recipients: '',
                    cc: '',
                    externalRecipient: '',
                    internetMail: null,
                    subject: '',
                    post_content: '',
                    attachment: []
                },
                uploadOptions: { // 上传参数
                    target: this.BASE_URL + "/api/resource/res_upload",
                    testChunks: false,
                    headers: {Authorization: `Bearer ` + this.$g.access_token}
                },
                statusText: { // 上传状态
                    success: "上传成功",
                    error: "上传出错",
                    uploading: "正在上传...",
                    paused: "暂停",
                    waiting: "等待上传"
                },
                tinymceOptions: { // 编辑器参数
                    // images_upload_handler: this.images_upload_handler,
                    language_url: CHINESE,
                    // images_upload_url: this.BASE_URL + "/api/resource/res_upload",
                    paste_data_images: false, // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
                    paste_convert_word_fake_lists: false, // 插入word文档需要该属性
                    paste_webkit_styles: "all",
                    paste_merge_formats: true,
                    nonbreaking_force_tab: false,
                    paste_auto_cleanup_on_paste: true, // 去掉文本里的样式
                    paste_preprocess: (plugin, args) => {
                        args.content = this.strip_tags(args.content);
                    }
                },
                rules: { // 表单规则验证
                    recipients: [
                        { required: true, message: '请输入收件人', trigger: 'change' }
                    ],
                    subject: [
                        { required: true, message: '请输入邮件主题', trigger: 'blur' }
                    ],
                    post_content: [
                        { required: true, message: '请输入邮件正文内容', trigger: 'blur' }
                    ]
                },
                receiverParam: { // 收件人列表参数
                    page_index: 1,
                    page_size: 10
                },
                viewLoading:{
                    status: false,
                    txt: '加载数据...'
                },
                viwPdfParam: {
                    src: '',
                    loadedRatio: 0,
                    page: 1,
                    numPages: 0,
                    rotate: 0
                },
                imgViewUrl: '',
                voiceViewUrl: '',
                playParam: {play_url: ''},
                showVideoPlayer: false,
                isActive: true,
                isPDFActive: true,
                imgVisible: false,
                voiceVisible: false,
            }
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.scrollFun, false);
        },
        components: {
            pdf,
            tinymce,
            baseHeader,
            videoAlertView
        },
        watch: {
            'sendForm.externalRecipient'(newVal, oldVal) {
                let str = newVal.split(/[,，]/g);

                if (str.length === 21) {
                    this.sendForm.externalRecipient = oldVal;
                    this.$message.warning('外部收件人最多可添加20个账号');
                }
            },
            'sendForm.post_content'(newVal, oldVal) {
                // if (this.editLoad === 0) {
                //     this.editLoad++;
                // } else {
                    setTimeout(() => {
                        let body = document.getElementById('d1_ifr').contentWindow.document.getElementsByTagName('body')[0].textContent;
                        let newLen = body.replace(/\s/g, '').length;
                        let oldLen = this.tinymceNum;

                        // 判断邮件长度是否超过 10000
                        if (newLen > 10000) {
                            this.$message.warning('邮件最大长度不可以超过 10000 个字');
                            this.tinymceNum = oldLen;
                            this.sendForm.post_content = oldVal;
                        } else {
                            this.tinymceNum = newLen;
                        }
                    }, 300);
                // }
            }
        },
        created() {
            // iframe 调用父级 vue 函数， 把函数挂载在 window 对象
            window['preview'] = (obj) => {
                this.preview(obj);
            };

            let mailListId = JSON.parse(sessionStorage.getItem('mailListId'));
            let hashId = this.$route.hash.split('#id=')[1];

            if ((mailListId && mailListId.drafts) || hashId) {
                this.isId = true;

                if (hashId) {
                    if (mailListId) {
                        sessionStorage.setItem('mailListId', JSON.stringify({...mailListId, ...{drafts: +hashId}}));
                    } else {
                        sessionStorage.setItem('mailListId', JSON.stringify({drafts: +hashId}));
                    }

                    this.sessionId = +hashId;
                    this.getList('drafts', +hashId);
                } else {
                    this.sessionId = mailListId.drafts;
                    this.getList('drafts', mailListId.drafts);
                }
            } else {
                this.getList();
            }
            
            this.getPlaformList();
            this.getInternetList();
        },
        mounted() {
            // 点击 sort_box 区域以外隐藏
            let that = this;
            document.addEventListener('click', function(e) {
                var e = e || window.event; //浏览器兼容性 
                var elem = e.target || e.srcElement;

                while (elem) { // 循环判断至跟节点，防止点击的是div的id=sort_box 
                    if (elem.id && (elem.id == 'sort_box' || elem.id == 'sort_img')) { 
                        return; 
                    } 

                    elem = elem.parentNode; 
                }
    
                that.is_sort = false;
                document.querySelector('#sort_box') && (document.querySelector('#sort_box').style.display = 'none'); // 点击的不是div或其子元素
            })
        },  
        methods: {
            strip_tags (str){
                //对img标签进行匹配
                let imgReg = /<img.*?(?:>|\/>)/gi;
                
                if(imgReg.test(str)) {
                    //将img标签替换为*
                    str =  str.replace(imgReg, "");
                }
                
                //处理html标签
                // mainContent =  mainContent.replace(/&nbsp;/gi," ");
                return str;
            },
            /**
             * 获取上一页数据
             */
            prePage() {
                let json = JSON.parse(sessionStorage.getItem('mailListId'));
                this.isId = false;
                this.mailIndex = null;
                this.listParam.page_index--;
                this.cancelChoose();
                
                if (json && json.drafts) {
                    this.getList('drafts', json.drafts);
                } else {
                    this.getList();
                }
            },
            /**
             * 获取下一页数据
             */
            nextPage() {
                let json = JSON.parse(sessionStorage.getItem('mailListId'));
                this.isId = false;
                this.mailIndex = null;
                this.listParam.page_index++;
                this.cancelChoose();
                
                if (json && json.drafts) {
                    this.getList('drafts', json.drafts);
                } else {
                    this.getList();
                }
            },
            /**
             * 获取收件箱列表
             * @param {String} name 操作标识
             * @param {Number} id 邮件 id
             */
            getList(name, id) {
                let success = (res => {
                    if (is_empty(res.data) && this.sessionId && this.isId) {
                        this.sessionId = null;
                        let mailListId = JSON.parse(sessionStorage.getItem('mailListId'));
                        sessionStorage.setItem('mailListId', JSON.stringify({...mailListId, ...{drafts: ''}}));
                        this.getList('search', '');
                    }

                    if (!is_empty(res.data)) {
                        this.listData = deep_clone(res.data.data);
                    }

                    this.selectedMail = [];
                    this.isChoose = false;
                    this.isAll = false;
                    this.loading.status = false;
                    this.searchMeunContent = false;
                    this.totalNum = res.data.data_sum;
                    this.listParam.page_size = res.data.page_size;
                    this.listParam.page_index = res.data.page_index;

                    if (Math.ceil(res.data.data_sum / res.data.page_size) == res.data.page_index) {
                        this.notNext = false;
                    } else {
                        this.notNext = true;
                    }

                     if (name === 'drafts' && this.listData.length > 0) {
                        this.getMailDetail({id: id}, 'drafts');
                    }

                    name === 'refresh' && (this.$message.success('刷新成功'));

                    if (name === 'search' && is_empty(this.listData)) {
                        this.searchMeunContent = true;
                    }

                    if (name === 'drafts') {                        
                        this.listData.forEach((item, index) => {
                            if (item.id === id) {
                                this.mailIndex = index;
                            }
                        })
                    }
                });

                this.loading.status = true;

                let orderField = 'create_time';
                switch(parseInt(this.listParam.key1)) {
                    case 1: 
                        orderField = 'file';
                        break;
                    default: 
                         orderField = 'create_time';
                }

                let params = {
                    flag: 2,
                    id: (this.sessionId && this.isId) ? this.sessionId : null,
                    start_time: null,
                    end_time: null,
                    subject: this.menuSearch,
                    content: this.menuSearch,
                    user_name: this.menuSearch,
                    file: null,
                    status: null,
                    order_field: orderField,
                    order: this.listParam.key2,
                    page_size: this.listParam.page_size,
                    page_index: (this.sessionId && this.isId) ? 0 : this.listParam.page_index,
                }

                this.$ajax({
                    url: "api/email/lists",
                    method: "get",
                    params: params,
                    func: {success: success}
                });
            },
            /**
             * 编辑器初始化
             */
            editorInit() {
                // 修改输入框内文字与边界的宽
                let dom = document.getElementById('d1_ifr').contentWindow.document.getElementById('tinymce');
                dom.style.margin = "8px 25px";

                let mailListId = JSON.parse(sessionStorage.getItem('mailListId'));

                if (mailListId && mailListId.drafts) {
                    this.getList('drafts', mailListId.drafts);
                } else {
                    this.getList();
            }
            },
            /**
             * 获取网络邮箱
             */
            getInternetList() {
                networkMailbox(this).then(res => {
                    this.internetList = res;
                })
            },
            /**
             * 获取平台列表
             */
            getPlaformList() {
                let success = (res => {
                    this.plaformList = res.data;

                    if (this.plaformList.length > 0) {
                        this.plaformId = this.plaformList[0].id;
                        this.receiver_keyword = null;
                        this.receiverParam = {
                            page_index: 1,
                            page_size: 10
                        }
                        this.getReceiverList();
                    }
                });

                this.$ajax({
                    url: "api/email/platform",
                    method: "get",
                    params: {},
                    func: {success: success}
                });
            },
            /**
             * 
             */
            scrollFun(event) {
                event = event || window.event;
                let target = event.target;
                let scrollH = target.scrollHeight - target.scrollTop - target.clientHeight;
                
                if (
                    this.scrollT < target.scrollTop
                    && scrollH < 20 
                    && this.isScroll 
                    && Math.ceil(this.receiverCount/this.receiverParam.page_size) > this.receiverParam.page_index) {
                    this.isScroll = false;
                    this.receiverParam.page_index++;
                    this.getReceiverData('scroll');
                }

                this.scrollT = target.scrollTop
            },
            getReceiverData(flag) {
                if (flag === 'search') {
                    this.receiverParam = {
                        page_index: 1,
                        page_size: 10
                    }
                }

                let success = (res => {
                    this.isScroll = true;
                    this.receiverCount = res.data.data_sum;

                    if (flag === 'scroll') {
                         res.data.data.forEach(item => {
                              this.receiverList.push(item);
                         })
                    } else {
                        document.querySelector('#scrollReceiver') && (document.querySelector('#scrollReceiver').scrollTop = 0);
                        this.receiverList = res.data.data;
                    }

                    if (flag !== 'add') {
                        this.setReceiverCcInfo();
                    }
                });
                let fail = (res => {
                    this.isScroll = true;
                    if (flag === 'scroll') {
                        this.receiverParam.page_index--;
                    }
                })
                let appCode = this.plaformList.filter(item => this.plaformId === item.id)[0].app_code;

                this.$ajax({
                    url: "api/email/receiver",
                    method: "get",
                    params: {
                        app_code: appCode,
                        keyword: this.receiver_keyword,
                        page_index: this.receiverParam.page_index,
                        page_size: this.receiverParam.page_size
                    },
                    func: {success: success, fail: fail}
                });
            },
            /**
             * 获取收件人列表
             */
             getReceiverList(flag) {
                document.removeEventListener('scroll', this.scrollFun, false);

                this.$nextTick(() => {
                    let domval = document.querySelector('#scrollReceiver');
                    domval && domval.addEventListener('scroll', this.scrollFun, false);
                })

                this.receiverList = [];
                this.getReceiverData();
            },
            /**
             * 显示全部角色
             * @param {Array} arr 角色
             */
            showRoleName(arr) {
                let name = arr ? arr.join('</br>') : '';
                return name;
            },
            /**
             * 根据关键字获取邮件列表
             */
            getSerach() {
                clearTimeout(this.timerSearch);
                this.timerSearch = null;
                
                this.timerSearch = setTimeout(() => {
                    this.isId = false;
                    this.listParam.page_index = 1;
                    this.getList('search');
                }, 500);
            },
            /**
             * 取消搜索
             */
            cancelSearch() {
                this.isId = true;
                this.menuHandle = 'all';
                this.menuSearch = '';
                
                this.getList();
            },
            /**
             * 刷新数据
             */
            refreshMail() {
                this.listParam = {
                    key1: 0,
                    key2: 'desc',
                    page_index: 1,
                    page_size: 12
                }

                this.mailIndex = null;
                this.isId = false;
                this.isSort = false;
                this.isAll = false;
                this.isChoose = false;
                this.menuSearch = '';
                this.selectedMail = [];

                this.getList('refresh');
            },
            /**
             * 选择邮件
             */
            chooseList() {
                this.isAll = false;
                this.isChoose = true;
            },
            /**
             * 取消单选和全选
             */
            cancelChoose() {
                this.isChoose = false;
                this.isAll = false;
                this.selectedMail = [];
            },
            /**
             * 点击选择邮件
             */
            handleMailChange(value) {},
            /**
             * 全选
             */
            checkAll() {
                this.isAll = true;
                this.isChoose = false;
                this.selectedMail = [];

                this.listData.forEach(item => {
                    this.selectedMail.push(item.id);
                })
            },
            /**
             * 删除邮件
             */
            deleteMail() {
                const success = (res => {
                    this.$message.warning('已删除进入废纸篓中');
                    this.mailIndex = null;
                    let mailListId = JSON.parse(sessionStorage.getItem('mailListId'));

                    if (this.listData.length === this.selectedMail.length && this.listParam.page_index > 1) {
                        this.listParam.page_index--;
                    }

                    if (mailListId && mailListId.drafts) {
                        if (this.selectedMail.indexOf(mailListId.drafts) > -1) {
                            this.itemDetail = {};
                            this.mailContent = false;
                            this.isId = false;
                            this.sessionId = null;
                            
                            sessionStorage.setItem('mailListId', JSON.stringify({...mailListId, ...{drafts: ''}}));
                        } 
                    }

                    this.selectedMail = [];
                    this.getList();
                })

                this.$ajax({
                    url: "api/email/garbagesingle",
                    method: "post",
                    data: {id: [...new Set(this.selectedMail)]},
                    func: {success: success}
                });
            },
            /**
             * 邮件排序
             */
            sortList() {
                this.isSort = true;
                this.isChoose = false;
                this.isAll = false;
                this.selectedMail = [];
            },
            /**
             * 取消排序
             */
            cancelSort() {
                this.isSort = false;
            },
            /**
             * 邮件排序条件
             * @param {Number} inx 下标
             */
            handleFilter(inx) {
                this.listParam.key1 = inx;
                this.isSort = false;

                this.getList();
            },
            /**
             * 邮件排序顺序
             * @param {String} id 标志
             */
            handleSort(id) {
                this.listParam.key2 = id;
                this.isSort = false;

                this.getList();
            },
            /**
             * 查看邮件内容
             * @param {Object} obj 邮件信息
             * @param {String} index 列表标识
             */
            checkMail(obj, index) {
                if (this.isChoose || this.isAll) { // 选中状态不能切换邮件内容
                    return false;
                } else {
                    this.getMailDetail(obj, '', index);
                }
            },
            /**
             * 获取邮件详细信息
             * @param {Object} obj 邮件信息
             * @param {String} name 操作标识
             */
            getMailDetail(obj, name, inx) {
                let success = (res => {
                    let exteranaName = '';
                    this.itemDetail = res.data;
                    this.ccList = [];
                    this.recipientList = [];
                    this.sendForm.attachment = [];

                    this.mailContent = true;
                    this.sessionId = obj.id;
                    
                    let mailListId = JSON.parse(sessionStorage.getItem('mailListId'));

                    if (mailListId) {
                        sessionStorage.setItem('mailListId', JSON.stringify({...mailListId, ...{drafts: obj.id}}));
                    } else {
                        sessionStorage.setItem('mailListId', JSON.stringify({drafts: obj.id}));
                    }

                    if (this.$route.hash.split('#id=')[1]) {
                        window.location.hash = `#id=${obj.id}`;
                    }

                    if (name !== 'drafts') {
                         this.mailIndex = inx;
                    }

                    !is_empty(this.itemDetail.user) && this.itemDetail.user.filter(val => val.receive_type == 3).forEach(val1 => {
                        exteranaName += val1.name + ';';
                    })

                    !is_empty(this.itemDetail.file) && this.itemDetail.file.forEach(val => {
                        this.sendForm.attachment.push({
                            id: val.id,
                            name: val.name,
                            postfix: val.postfix
                        })
                     })

                    this.sendForm.subject = this.itemDetail.subject;
                    this.sendForm.recipients = 'receiver';
                    this.sendForm.internetMail = this.itemDetail.config_id == 0 ? null : this.itemDetail.config_id;
                    this.sendForm.externalRecipient = exteranaName;

                    this.setReceiverCcInfo('info');
                    this.setEditorContent();

                    this.$nextTick(() => {
                        let self = this;
                        let source = document.getElementById('d1_ifr').contentWindow.document.getElementById('tinymce').querySelectorAll('.download-source');
                        let previewS = document.getElementById('d1_ifr').contentWindow.document.getElementById('tinymce').querySelectorAll('.click-span-preview');
                        
                        source.forEach(item => {
                            item.addEventListener('click', function(ev) {
                                window.location.href = ev.currentTarget.dataset.link;
                            }, false)
                        })
                        previewS.forEach(item => {
                            item.addEventListener('click', function(ev) {
                                self.previewFile({id: +ev.currentTarget.dataset.id, file_type: +ev.currentTarget.dataset.type});
                            }, false)
                        })
                    })
                });
                let fail = (res => {
                    this.$message.error(res.msg)
                    this.getList();
                })

                this.$ajax({
                    url: "api/email/single",
                    method: "get",
                    params: {id: obj.id},
                    func: {success: success, fail: fail}
                });
            },
            /**
             * 预览附件
             * @param {Object} obj 附件信息
             * 文件类型（1：文档；2：日志；3：图片；4：压缩文件；5：音频文件；6：视频；7：应用程序；8：其他）
             */
            previewFile(obj) {
                this.viewLoading.status = true;

                switch(parseInt(obj.file_type)) {
                    case 1:
                        this.isPDFActive = false;
                        break;
                    case 3:
                        this.imgVisible  = true;
                        break;
                    case 5:
                        this.voiceVisible = true;
                        break;
                    case 6:
                        this.isActive = false;
                        break;
                    default: 
                        this.$message.warning("不支持预览的资源类型");
                        return false;
                }

                let success = ( res => {
                    let result  = res.data;

                    switch(parseInt(obj.file_type)) {
                        case 1:
                            this.pdfView( result.path);
                            break;
                        case 3:
                            this.imgView(result.path);
                            break;
                        case 5:
                            this.voiceView(result.path);
                            break;
                        case 6:
                            this.videoView(result.path);
                            break;
                        default: 
                            this.$message.warning("不支持预览的资源类型");
                    }
                })
                let fail = (res => {
                    this.viewLoading.status = false;
                    this.$message.error(res.msg);
                })
                
                this.$ajax({
                    url: "api/resource/view_info",
                    method: "get",
                    params: {
                        id: obj.id, 
                        is_email_file: 1
                    },
                    func: {
                        success: success,
                        fail: fail
                    }
                });
            },
            /**
             * 关闭音频播放
             */
            closeAudio() {
                this.voiceVisible = false;
                document.getElementById("voicepoauy").pause();
            },
            /**
             * 音频预览
             */
            voiceView(url) {
                this.voiceViewUrl = url;
                document.getElementById("voicepoauy").load();	
            },
            /**
             * 图片预览
             */
            imgView(url) {
                this.imgViewUrl = url;
            },
            /**
             * 文档预览
             */
            pdfView(url) {
                this.viwPdfParam.src = pdf.createLoadingTask(url);
            },
            /**
             * 改变文档页数
             */
            pdfPageChange(val) {
                this.viwPdfParam.page  = val;
            },
            /**
             * 文档预览失败
             */
            pdfError: function(err) {
                this.$message.error('读取文件失败');
            },
            /**
             * 关闭文档预览
             */
            closePdfView() {
                this.isPDFActive = true;
            },
            /**
             * 关闭视频预览
             */
            closeVideoView() {
                this.showVideoPlayer = false;
                this.isActive = true;
            },
            /**
             * 视频预览
             */
            videoView(url) {
                this.showVideoPlayer = true;
                this.playParam.play_url = url;
            },
            /**
             * 获取收件人和抄送人信息
             */
            setReceiverCcInfo(flag) {
                let ccTemp = is_empty(this.itemDetail.user) ? [] : this.itemDetail.user.filter(val => val.receive_type == 2);

                if (flag === 'info' && is_empty(this.receiverList)) {
                    this.recipientList.push({
                        id: this.itemDetail.create_id,
                        name: this.itemDetail.user_name
                    })

                    ccTemp.forEach(val2 => {
                        this.ccList.push({
                            id: +val2.receiver,
                            name: val2.name
                        })
                    })
                } else {
                    this.ccList = [];
                    this.recipientList = [];

                    this.receiverList.forEach(item10 => {
                        if (item10.id === this.itemDetail.create_id) {
                            this.recipientList.push({
                                id: item10.id,
                                number: item10.number,
                                name: item10.name,
                                platform_name: item10.platform_name,
                                role_name: item10.role_name
                            })
                        }
                    })
                    
                    ccTemp.forEach(val2 => {
                        this.receiverList.forEach(item10 => {
                            if (item10.id === +val2.receiver) {
                                this.ccList.push({
                                    id: item10.id,
                                    number: item10.number,
                                    name: item10.name,
                                    platform_name: item10.platform_name,
                                    role_name: item10.role_name
                                })
                            }
                        })
                    })
                }
            },
            /**
             * 编辑器添加邮件内容
             */
            setEditorContent() {
                let body = document.getElementById('d1_ifr').contentWindow.document.getElementsByTagName('body');
                this.sendForm.post_content = this.itemDetail.content;
                body.innerHTML = this.itemDetail.content;
            },
            /**
             * 保存至草稿箱
             */
            submitDrafts(){
                this.loading.status = true;

                let userList = [];
                let strMail = this.sendForm.externalRecipient.split(/[,，]/g); 

                this.recipientList.forEach(item => {
                    userList.push({
                        receiver: item.id,
                        receive_type: 1
                    })
                })

                this.ccList.forEach(item => {
                    userList.push({
                        receiver: item.id,
                        receive_type: 2
                    })
                })

                strMail.forEach(item => {
                    if (item != '') {
                        userList.push({
                            receiver: item,
                            receive_type: 3
                        })
                    }
                })

                let params = {
                    id: this.itemDetail.id,
                    subject: this.sendForm.subject,
                    type: 1,
                    obj_id: 0,
                    config_id: this.sendForm.internetMail,
                    content: this.sendForm.post_content,
                    submit_type: 0,
                    user: userList,
                    file: this.sendForm.attachment
                }
                    
                const success = (res => {
                    this.loading.status = false;
                    this.$message.success('邮件已保存至草稿箱');
                })

                const fail = (res => {
                    this.loading.status = false;
                    this.$message.error(res.msg);
                })

                this.$ajax({
                    url: "api/email/single",
                    method: "post",
                    // headers: {'Content-Type': 'application/json;charset=UTF-8'},
                    // params: params,
                    data: params,
                    func: {success: success, fail: fail}
                });
            },
            /**
             * 发生邮件
             * @param {String} formName 表单标识
             */
            submitMail(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.isExternalRecipient) {
                            return false;
                        }
                        this.loading.status = true;

                        let userList = [];
                        let strMail = this.sendForm.externalRecipient.split(/[,，]/g); 

                        this.recipientList.forEach(item => {
                            userList.push({
                                receiver: item.id,
                                receive_type: 1
                            })
                        })

                        this.ccList.forEach(item => {
                            userList.push({
                                receiver: item.id,
                                receive_type: 2
                            })
                        })

                        strMail.forEach(item => {
                            if (item != '') {
                                userList.push({
                                    receiver: item,
                                    receive_type: 3
                                })
                            }
                        })

                        let params = {
                            id: this.itemDetail.id,
                            subject: this.sendForm.subject,
                            type: 1,
                            obj_id: 0,
                            config_id: this.sendForm.internetMail,
                            content: this.sendForm.post_content,
                            submit_type: 1,
                            user: userList,
                            file: this.sendForm.attachment
                        }
                         
                        const success = (res => {
                            let _this = this;
                            this.loading.status = false;
                            this.$message.success('邮件发送成功');
                            this.isId = false;
                            this.sessionId = null;
                            let mailListId = JSON.parse(sessionStorage.getItem('mailListId'));

                            sessionStorage.setItem('mailListId', JSON.stringify({...mailListId, ...{drafts: '', sent: this.itemDetail.id}}));
                          
                            
                            setTimeout(() => {
                                _this.$router.push(`/email/sent`);
                            }, 500);
                        })

                        const fail = (res => {
                            this.loading.status = false;
                            this.$message.error(res.msg);
                        })

                        this.$ajax({
                            url: "api/email/single",
                            method: "post",
                            // headers: {'Content-Type': 'application/json;charset=UTF-8'},
                            // params: params,
                            data: params,
                            func: {success: success, fail: fail}
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 添加收件人
             * @param {String} val 有值为抄送，反之为收件人
             */
            addFormRecipient(val = '') {
                this.pop_up = true;

                if (val === 'cc') {
                    this.recipientCC = true;
                    this.people_lsit = deep_clone(this.ccList);
                } else {
                    this.people_lsit = deep_clone(this.recipientList);
                }

                if (this.plaformList.length > 0) {
                    this.plaformId = this.plaformList[0].id;
                    this.receiver_keyword = null;
                    this.receiverParam = {
                        page_index: 1,
                        page_size: 10
                    }
                    this.getReceiverList('add');
                }
            },
            /**
             * 添加收件人
             * @param {Number} inx 收件人列表下标
             */
            addRecipient(inx) {
                if (this.people_lsit.length >= 20) {
                    this.$message.error('最多只能选择20个用户');
                    return false;
                }

                // 发件人和抄送人不可以相同
                if (this.recipientCC) {
                    for (let i=0, len=this.recipientList.length; i<len; i++) {
                        if (this.recipientList[i].id === this.receiverList[inx].id) {
                            this.$message.error('发件人和抄送人不可以为同一个用户');
                            return false;
                        }
                    }
                } else {
                    for (let i=0, len=this.ccList.length; i<len; i++) {
                        if (this.ccList[i].id === this.receiverList[inx].id) {
                            this.$message.error('发件人和抄送人不可以为同一个用户');
                            return false;
                        }
                    }
                }

                // 不可重复添加相同人员
                if (!is_empty(this.people_lsit)) {
                    let len = this.people_lsit.length;

                    for (let i=0; i<len; i++) {
                        if (this.people_lsit[i].id === this.receiverList[inx].id) {
                            this.$message.error('不可重复添加相同人员');
                            return false;
                        }
                    }

                    this.people_lsit.push(deep_clone(this.receiverList[inx]));
                } else {
                    this.people_lsit.push(deep_clone(this.receiverList[inx]));
                }

            },
            /**
             * 添加全部收件人 
             */
            addAllRecipient() {
                if (this.people_lsit.length >= 20) {
                    this.$message.error('最多只能选择20个用户');
                    return false;
                }

                
                let _temp = [];

                this.receiverList.forEach(item1 => {
                    let falg = true;
                    let _item = [];

                    // 发送人和抄送人不可以相同
                    if (this.recipientCC) {
                        _item = deep_clone(this.recipientList.filter(item => item.id === item1.id));
                    } else {
                        _item = deep_clone(this.ccList.filter(item => item.id === item1.id));
                    }

                    // 不可重复添加相同人员
                    if (is_empty(_item)) {
                        this.people_lsit.forEach(item2 => {
                            if (item1.id === item2.id) {
                                falg = false;
                            }
                        })

                        falg && _temp.push(item1);
                    }
                })

                if (_temp.length === 0) {
                    this.$message.error('不可重复添加相同人员');
                    return false;
                }

                if (_temp.length + this.people_lsit.length > 20) {
                    this.$message.error('最多只能选择20个用户');
                    return false;
                }

                this.people_lsit = [...deep_clone(this.people_lsit), ...deep_clone(_temp)];
            },
            /**
             * 关闭选择收件人
             */
            closeRecipient() {
                this.pop_up = false;
                this.recipientCC = false;
                this.people_lsit = [];
                this.receiverList = [];
                this.receiver_keyword = null;
                this.receiverParam = {
                    page_index: 1,
                    page_size: 10
                }
            },
            /**
             * 删除选中的收件人
             * @param {Number} inx 选中人员下标
             */
            deleteRecipient(inx) {
                this.people_lsit.splice(inx, 1);
            },
            /**
             * 保存选择的收件人
             */
            newRecipient() {
                if (this.recipientCC) {
                    this.ccList = deep_clone(this.people_lsit);
                    this.recipientCC = false;
                } else {
                    this.recipientList = deep_clone(this.people_lsit);
                    this.sendForm.recipients = 'receiver';
                }

                this.closeRecipient();
            },
            /**
             * 清空收件人
             * @param {String} val 有值为抄送，反之为收件人
             */
            clearRecipient(val) {
                if (val === 'cc') {
                    this.ccList = [];
                } else {
                    this.recipientList = [];
                    this.sendForm.recipients = '';
                }

                this.$message.warning('无收件人');
            },
            /**
             * 删除一个收件人
             * @param {Number} inx 数组下标
             */
            clearReceiver(inx) {
                this.recipientList.splice(inx, 1);
            },
           /**
             * 删除一个抄送收件人
             * @param {Number} inx 数组下标
             */
            clearCC(inx) {
                this.ccList.splice(inx, 1);
            },
            /**
             * 验证外部收件人邮箱是否正确
             */
            blurExternalRecipient() {
                if (is_empty(this.sendForm.externalRecipient)) {
                    return false;
                }

                let temp = this.sendForm.externalRecipient.slice(-1);
                let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                let str = this.sendForm.externalRecipient.split(/[,，]/g);
                let dom = document.querySelector('#external_recipient').classList;

                (temp === ',' || temp === '，') && str.pop();

                dom.remove('external-recipient-success');
                dom.remove('external-recipient-error');

                for (let i=0; i<str.length; i++) {
                    if (!reg.test(str[i])) {
                        this.$message.error(`第${i+1}个外部收件人邮箱格式不正确`);
                        dom.add('external-recipient-error');
                        this.isExternalRecipient = true;
                        return;
                    }
                }

                this.isExternalRecipient = false;
                dom.add('external-recipient-success');
            },
            /**
             * 移除上传的附件
             * @param {String} name 附件名称
             */
            delAttachment(name) {
                this.sendForm.attachment = this.sendForm.attachment.filter(function(item) {
                    return item.name !== name;
                })

                this.$refs.uploader.uploader.fileList = this.$refs.uploader.uploader.fileList.filter(function(item) {
                    return item.name !== name;
                })

                this.$refs.uploader.uploader.files = this.$refs.uploader.uploader.files.filter(function(item) {
                    return item.name !== name;
                })
            },
            /**
             * 过滤附件
             */
            fileAdded(file) {
                if (file.size > 100*1024*1024) {
                    this.$message.error('附件大小为100M内');
                    file.ignored = true;
                    return false;
                }

                this.percentage = 0;
                this.progressing = true;
                this.disabledUplader = true;
            },
            /**
             * 所选择的附件添加到上传队列后触发
             */
            fileSubmit(files, fileList, event){},
            /**
             * 附件上传中
             */
            fileProgress() {
                this.percentage = parseInt(this.$refs.uploader.uploader.progress() * 100);
            },
            /**
             * 取消上传
             */
            fileCancel() {
                this.$refs.uploader.uploader.cancel();
                this.disabledUplader = false;
            },
            /**
             * 移除附件
             */
            fileRemoved(file) {
                this.progressing = false;
                this.disabledUplader = false;
            },
            /**
             * 上传附件成功
             */
            fileSuccess(rootFile, file, message, chunk) {
                this.progressing = false;
                this.disabledUplader = false;
                let mess = eval("(" + message + ")");
                 mess = handleResponseData(mess);
                this.sendForm.attachment.push({
                    path: mess.data.file_path,
                    // type: mess.data.file_type,
                    name: mess.data.file_name,
                    postfix: mess.data.post_fix
                })
            },
            /**
             * 上传附件失败
             */
            fileFail(rootFile, file, message, chunk) {
                this.progressing = false;
                let mess = eval("(" + message + ")");

                if (parseInt(mess.error) === 401 && this.uploadRetryTimes > 0) {
                    let callbcak = data => {
                        this.uploadRetryTimes--;
                        this.$refs.uploader.uploader.retry(file);
                    };
                    this.get_access_token(callbcak);
                } else {
                    this.disabledUplader = false;
                    this.$message.error(mess.msg);
                }
            },
            /**
             * 路由跳转
             * @param {String} name 具体页面
             */
            linkTo(name) {
                this.$router.push(`/email/${name}`);
            },
            /**
             * 编辑器图片上传
             * @param {bolb} blobInfo 图片数据
             * @param {Function} success 成功时的回调函数
             * @param {Function} failure 失败时的回调函数
             */
            images_upload_handler(blobInfo, success, failure) {
                if (blobInfo.blob().type.indexOf("image/") === -1) {
                    failure("只允许上传图片格式的文件");
                // } else if (blobInfo.blob().size > 2048000) {
                //     failure("图片大小不能超过2M");
                } else {
                    let formData = new FormData();
                    formData.append("file", blobInfo.blob(), blobInfo.filename());
                    let succ = data => {
                        data.data=data.data.data;
                        success(this.BASE_URL + data.data.data.file_path);
                    };
                    let fail = data => {
                        data.data=data.data.data;
                        failure(data.data.data.message);
                    };

                    /****************** 不知为何要重新create *****************/
                    const instance = axios.create({
                        headers: {
                            Authorization: `Bearer ${this.$g.access_token}`,
                            DecisionPlatform: ` ${this.$g.access_token}`,
                            token: localStorage.getItem("token")
                        },
                        withCredentials: true
                    });

                    instance.post("api/resource/res_upload", formData)
                    .then(succ)
                    .catch(fail);
                }
            }
        }
    }
</script>

<style lang="scss">
    .drafts-mail {
        height: 100%;

        .add-recipients-dialog {
            .el-dialog__body {
                padding: 20px 20px 0 20px;
            }

            .el-dialog-pop-up {
                display: flex;

                >div:first-child {
                    width: 270px;

                    .el-select {
                        width: 255px;
                    }

                    .org-people-box {
                        >div {
                            margin-top: 20px;
                            margin-right: 15px;
                            height: 290px;
                            border: 1px solid #DDDDDD;
                            overflow: hidden;
                            overflow-y: auto;

                            .org-people-item {
                                display: flex;
                                align-items: center;
                                padding: 10px 15px;
                                font-size: 12px;

                                span:first-child {
                                    width: 110px;
                                    // overflow: hidden;
                                    // text-overflow: ellipsis;
                                    // white-space: nowrap;
                                }

                                span:nth-child(2) {
                                    flex: 1;
                                }

                                span:last-child {
                                    font-size: 12px;
                                    width: 35px;
                                    color: #3D70AF;
                                    text-align: center;
                                    cursor: pointer;
                                }
                            }
                        }

                        >p {
                            width: 255px;
                            height: 38px;
                            line-height: 38px;
                            color: #348EFC;
                            font-size: 12px;
                            text-align: center;
                            border: 1px solid #DDDDDD;
                            border-top: none;
                            box-sizing: border-box;
                            cursor: pointer;
                        }
                    }
                }

                >div:last-child {
                    flex: 1;

                    .el-dialog-pop-keyword {
                        .el-input {
                            margin-right: 10px;
                            width: 242px;
                        }

                        button {
                            width: 82px;
                        }
                    }

                    .el-show-pepole {
                        >div {
                            margin-top: 20px;
                            height: 290px;
                            font-size: 12px;
                            border: 1px solid #DDDDDD;
                            overflow: hidden;
                            overflow-y: auto;

                            >div:first-child{
                                height: 36px;
                                line-height: 36px;
                            }

                            >div:not(:first-child) {
                                margin: 16px 0;
                            }

                            >div {
                                span {
                                    display: inline-block;
                                }

                                span:first-child {
                                    width: 30px;

                                    i {
                                        color: #D8D8D8;
                                        font-size: 16px;
                                    }
                                }

                                span:nth-child(2) {
                                    width: 170px;
                                }

                                span:nth-child(3) {
                                    width: 114px;
                                }

                                span:nth-child(4) {
                                    width: 94px;
                                }
                            }

                            >div:first-child {
                                background: #F5F5F5;
                            }

                            >div:not(:first-child) {
                                span:first-child {
                                    text-align: center;
                                    visibility: hidden;
                                    cursor: pointer;
                                }
                            }

                            >div:not(:first-child):hover {
                                span:first-child {
                                    visibility: visible;
                                }
                            }
                        }

                        >p {
                            width: 540px;
                            height: 38px;
                            line-height: 38px;
                            color: #348EFC;
                            font-size: 12px;
                            text-align: center;
                            border: 1px solid #DDDDDD;
                            border-top: none;
                            box-sizing: border-box;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .drafts-content {
            display: flex;
            height: calc(100% - 68px);
            background: #fff;

            .main-menu {
                position: relative;
                width: 360px;
                height: 100%;
                border-right: 1px solid #EBEBEB;

                .menu-handle {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    padding: 20px 60px 20px 30px;
                    height: 60px;
                    border-bottom: 1px solid #EBEBEB;
                    box-sizing: border-box;

                    img {
                        cursor: pointer;
                    }
                }

                .menu-handle-search {
                    .el-input--suffix {
                        width: 220px;

                        input {
                            height: 32px;
                        }

                        i {
                            line-height: 32px;
                        }
                    }

                    >span {
                        font-size: 14px;
                        color: #586F8B;
                        cursor: pointer;
                    }
                }

                .sort-filter {
                    position: absolute;
                    top: 60px;
                    right: 0;
                    width: 140px;
                    background: #fff;
                    box-shadow: 0 2px 14px 0 rgba(184,184,184,0.50);
                    z-index: 9999;

                    .line {
                        margin: 0 10%;
                        height: 1px;
                        background:#EBEBEB;
                    }

                    .box-sort {
                        padding: 10px 0;

                        .text {
                            font-size: 12px;
                            text-align: center;
                            height: 30px;
                            line-height: 30px;
                            color: #000000;
                            cursor: pointer;
                        }

                        .text-active {
                            background: #EAF7FF;
                        }
                    }
                }

                .no-search-menu-content {
                    margin-top: 20px;
                    font-size: 14px;
                    text-align: center;
                    color: #A5A5A5;
                }

                .no-menu-content {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    height: calc(100% - 60px);

                    p {
                        margin-top: 30px;
                        font-size: 16px;
                        color: #999999;
                    }
                }

                .menu-conten {
                    height: calc(100% - 60px);
                    overflow-y: auto;

                    .page-turning {
                        position: absolute;
                        bottom: 2px;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        height: 30px;
                        font-size: 16px;
                        background: #f5f7fa;
                        border-top: 1px solid #EBEBEB;

                        >span {
                            margin-right: 20px;
                            cursor: pointer;
                        }
                    }

                    .el-scrollbar {
                        margin-bottom: 27px;
                    }

                    .menu-list-active {
                        background: #EAF7FF;
                    }

                    .menu-list {
                        display: flex;
                        align-items: center;
                        padding: 10px 20px 10px 30px;
                        border-bottom: 1px solid #EBEBEB;
                        cursor: pointer;

                        .menu-left {
                            width: 30px;

                            .el-checkbox__label {
                                display: none;
                            }
                        }

                        .menu-right {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            flex: 1;
                            width: 0;

                            >div:first-child {
                                display: flex;
                                align-items: center;
                                flex: 1;
                                max-width: 170px;

                                >img {
                                    margin-right: 20px;
                                }

                                div {
                                    display: flex;
                                    flex-direction: column;
                                    width: calc(100% - 30px);

                                    span {
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }

                                    span:first-child {
                                        padding-bottom: 5px;
                                        font-size: 14px;
                                        color: #000000;
                                    }

                                    span:last-child {
                                        font-size: 12px;
                                        color: #333333;
                                    }
                                }
                            }

                            .time {
                                display: flex;
                                justify-content: center;
                                align-items: flex-end;
                                flex-direction: column;
                                width: 135px;
                                font-size: 12px;
                                color: #999999;
                                flex-direction: inherit;
                                justify-content: space-between;

                                span {
                                    padding-bottom: 5px;
                                    word-break: break-all;
                                    display: inline-block;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    flex: 1;
                                    max-width: 135px;
                                }
                            }
                        }
                    }
                }
            }

            .no-mail-data {
                padding: 80px 100px;
                width: calc(100% - 360px);
                height: 100%;
                background: url('./../../../assets/email/images/no-mail.png') no-repeat 50% 50%;
                box-sizing: border-box;

                .text {
                    font-size: 18px;
                    color: #999999;
                }
            }

            .main-conten {
                position: relative;
                width: calc(100% - 360px);
                height: 100%;
                overflow: auto;
                box-sizing: border-box;

                .send-mail-main {
                    padding: 30px 40px 30px 30px;
                    height: calc(100% - 81px);
                    background: #fff;
                    box-sizing: border-box;
                    overflow-y: auto;

                    .demo-send-form {
                        .uploader-example {
                            .uploader-btn {
                                color: #fff;
                                border-radius: 4px;
                                border: 1px solid #8199C7;
                                background: #8199C7;
                            }

                            .uploader-progress {
                                display: none;
                            }

                            .uploader-progress-active {
                                display: inline-block;
                                margin-left: 30px;
                                font-size: 14px;

                                >div {
                                    display: flex;
                                    align-items: center;

                                    >div {
                                        width: 200px;
                                    }

                                    >span:nth-child(2) {
                                        margin-left: 16px;
                                        color: #348EFC;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }

                        .tinymce-num {
                            position: absolute;
                            right: 0;
                            bottom: 1px;
                            display: block;
                            padding-right: 35px;
                            width: calc(100% - 1px);
                            text-align: right;
                            font-size: 12px;
                            color: #999;
                            background: #F9F9F9;
                            box-sizing: border-box;
                        }

                        .el-input input {
                            font-size: 15px;
                            color: #000;
                        }

                        .external-recipient-success {
                            color: #348EFC;
                            border: 1px solid #348EFC;
                        }

                        .external-recipient-error {
                            color: #F56C6C;
                            border: 1px solid #F56C6C;
                        }

                        #d1_ifr {
                            height: 426px !important;
                        }

                        .mail-content {
                            >div {
                                position: relative;
                            }

                            .content-tip-hidden {
                                display: none !important;
                            }

                            .mce-statusbar.mce-container.mce-panel.mce-stack-layout-item.mce-last {
                                display: none;
                            }
                        }

                        .mce-tinymce.mce-container.mce-panel[role=application] >div >div:first-child >div >div:first-child   {
                            display: none;
                        }

                        .mce-tinymce.mce-container.mce-panel[role=application] >div >div:first-child >div >div:last-child >div >div:first-child {
                            display: none;
                        }
                    }

                    .send-form-recipients .el-form-item__content >div:first-child {
                        display: inline-block;
                        width: calc(100% - 182px);
                    }

                    .send-form-cc,
                    .send-form-recipients .el-form-item__content >div:first-child {
                        padding-left: 16px;
                        padding-right: 16px;
                        font-size: 12px;
                        color: #999999;
                        background: #F9F9F9;
                        border: 1px solid #DDDDDD;
                        border-radius: 4px;
                        cursor: default;
                        box-sizing: border-box;

                        >span {
                            margin-right: 10px;
                            padding: 11px 0;
                            font-size: 14px;
                            cursor: pointer;

                            >i {
                                padding-left: 5px;
                                color: #ccc;
                            }
                        }

                        >span:last-child {
                            >span {
                                display: none;
                            }
                        }

                        >span:hover {
                            color: #000;
                            
                            i {
                                color: #C77676;
                            }
                        }
                    }

                    .send-form-internet .el-form-item__content {
                        .el-select {
                            width: 400px;
                        }

                        >span {
                            margin-left: 20px;
                            font-size: 12px;
                            color: #666666;
                        }
                    }

                    .send-form-attachment-list {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;

                        >span {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-right: 30px;
                            font-size: 14px;
                            color: #586F8B;

                            span {
                                padding: 0 12px 0 8px;
                            }

                            i {
                                font-size: 18px;
                                color: #ccc;
                                cursor: pointer;
                            }

                            i:hover {
                                color: #C77676;
                            }
                        }
                    }

                    .no-attachment {
                        font-size: 12px;
                        color: #999999;
                    }

                    .send-form-reciver {
                        display: inline-block;

                        span {
                            font-size: 12px;
                            color: #3D70AF;
                            cursor: pointer;
                        }
                        
                        >span:first-child {
                            margin-left: 30px;
                        }

                        >span:last-child {
                            margin-left: 20px;
                        }
                    }

                    .send-form-btn {
                        span {
                            padding: 7px 10px;
                            font-size: 12px;
                            color: #fff;
                            border-radius: 4px;
                            cursor: pointer;
                        }

                        span:first-child {
                            background: #708DC4;
                        }

                        span:last-child {
                            margin-left: 10px;
                            background: #C77676;
                        }
                    }
                }

                .send-mail-footer {
                    width: 100%;
                    height: 80px;
                    line-height: 80px;
                    text-align: center;
                    background: #F9F9F9;

                    >span:first-child {
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }

                    >span:last-child {
                        margin-left: 40px;
                        padding: 6px 12px;
                        font-size: 14px;
                        color: #fff;
                        background: #348EFC;
                        border-radius: 2px;
                        cursor: pointer;
                    }

                    span {
                        vertical-align: middle;

                        img {
                            margin-right: 8px;
                            vertical-align: middle;
                        }
                    }
                }
            }
        }

        .activeLive{
			opacity: 0;
			visibility: hidden;
		}

        // .el-dialog__wrapper{
		// 	.el-dialog__body {
        //         text-align: center;
		// 		padding: 0;
        //     }
		// }

        .masking_h {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px;
            height: 40px;
            background: #348EFC;

            >span,
            >i {
                font-size: 16px;
                color: #fff;
            }

            >i{
                cursor: pointer;
            }
        }

        .video-preview {
            display: flex;
            justify-content: center;
            align-items: center;
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: .5s;
			background: rgba(0, 0, 0, 0.5);
			z-index: 3;

            .maskingBox {
                width: 70vw;
                height: 70vh;
                max-width: 1000px;
                max-height: 600px;
				background: #fff;
			}

            .masking_c {
                height: calc(100% - 40px);
                box-sizing: border-box;

                >div >div {
                    height: 600px;
                }
            }
        }

        .document-preview {
			display: flex;
            justify-content: center;
            align-items: center;
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: .5s;
			background: rgba(0, 0, 0, 0.5);
			z-index: 3;

			.maskingBox {
                width: 70vw;
                height: 70vh;
                max-width: 1200px;
                max-height: 900px;
				background: #fff;
			}

            .masking_c {
                height: calc(100% - 40px);
                box-sizing: border-box;

                >div {
                    height: 100%;

                    .pdf-view{
                        height: calc(100% - 70px);
                        overflow: hidden;
                        overflow-y: auto;

                        >span {
                            width: 100%;
                        }
                    }

                    .el-pagination {
                        padding: 20px 0;
                        text-align: center;
                        height: 70px;
                        box-sizing: border-box;
                    }
                }
            }
        }

		.picture-preview {
			display: flex;
            align-items: center;
            justify-content: center;
			margin: 0;

            .el-dialog {
                margin: 0;
                margin-top: 0 !important;
                width: 70vw;
                height: 70vh;
                max-width: 1200px;
                max-height: 900px;
                overflow: hidden;

                .el-dialog__body {
                    padding: 20px 0;
                    width: 100%;
                    height: calc(100% - 40px);
                    box-sizing: border-box;

                    div {
                        padding: 20px 40px 40px;
                        width: 100%;
                        height: 100%;
                        overflow-y: auto;
                        box-sizing: border-box;

                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }

        .audio-preview {
            display: flex;
            align-items: center;
            justify-content: center;
			margin: 0;

            .el-dialog {
                margin: 0;
                margin-top: 0 !important;
                width: 500px;
                height: 300px;

                .el-dialog__body {
                    padding: 20px 0;
                    width: 100%;
                    height: calc(100% - 40px);
                    box-sizing: border-box;

                    div {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 0 40px;
                        width: 100%;
                        height: 100%;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }
</style>